import { Chip } from '@mui/material';
import { TipoUpload } from '../../../models/enum';
import getLabelTipoUpload from '../getLabelTipoUpload';
import { tintDeCor } from './tintDeCor';

type Props = {
  tipo?: TipoUpload;
};

/**
 * Origem do arquivo é **categoria**, não status: numa lista de uploads o usuário
 * distingue "nota de corretagem" de "posições B3" de "Pluggy" pela cor. Cada
 * tipo mantém a SUA cor, renderizada como tint do sistema via `tintDeCor`
 * (ver o comentário longo em `tintDeCor.ts`).
 *
 * Quem sinaliza erro/pendência de importação é o card do upload, não este chip.
 */
const CORES: Record<TipoUpload, string> = {
  [TipoUpload.NOTA]: '#546e7a',
  [TipoUpload.CEI]: '#00897b',
  [TipoUpload.NEGOCIACOES_B3]: '#5c6bc0',
  [TipoUpload.MOVIMENTACOES_B3]: '#7e57c2',
  [TipoUpload.POSICOES_B3]: '#26a69a',
  [TipoUpload.JSON_KLAVI]: '#ef6c00',
  [TipoUpload.JSON_PLUGGY]: '#6d4c41',
};

export default function ChipTipoUpload({ tipo }: Props) {
  if (!tipo) return <></>;

  const cor = CORES[tipo] ?? '#546e7a';

  return (
    <Chip
      label={getLabelTipoUpload(tipo)}
      size="small"
      sx={(theme) => tintDeCor(cor, theme)}
    />
  );
}
